export const templateConstante = Object.freeze({
  TEMPLATE_DATA: "modelData",
  TEMPLATE_VARIABLES: "moduleList",
  TEMPLATE_CONDITIONS: "moduleConditions",

  TEMPLATE_DOCUMENT_TYPE: "1",
  TEMPLATE_MAIL_TYPE: "2",
});
